import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App.jsx'
import './index.css'
import QueryProvider from './providers/QueryProvider.jsx'
import './lib/api.js'

// Bootstrap token from URL hash once: #token=...
;(function bootstrapTokenFromHash(){
  if (typeof window === 'undefined') return
  const hash = window.location.hash || ''
  const match = hash.match(/(?:^|#|&)token=([^&]+)/)
  if (match && match[1]) {
    try {
      const token = decodeURIComponent(match[1])
      if (token) {
        localStorage.setItem('token', token)
      }
    } catch {}
    // Clean hash to avoid leaking token
    const url = window.location.origin + window.location.pathname + window.location.search
    window.history.replaceState({}, document.title, url)
  }
})()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryProvider>
        <App />
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </QueryProvider>
    </BrowserRouter>
  </React.StrictMode>,
) 